import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ServiceAndProductMappingCountService } from '../../../api/service-and-product-mapping-count.service';

@Component({
  selector: 'app-service-and-product-mapping-count',
  templateUrl: './service-and-product-mapping-count.component.html',
})
export class ServiceAndProductMappingCountComponent implements OnInit {
  public dataSource: any;
  public countData: any;

  private _destroyed$ = new Subject();

  constructor(private serviceAndProductMappingCountService: ServiceAndProductMappingCountService) { }

  ngOnInit() {
	this.serviceAndProductMappingCountService.getServiceAndProductMappingCountByUser()
		.pipe(takeUntil(this._destroyed$))
		.subscribe(res => {
		if (res) {
			this.countData = {
			fields: [
				{
				caption: 'Report',
				dataField: 'ReportName',
				area: 'filter',
				},
				{
				caption: 'User',
				dataField: 'ModifiedByUserFullNameSortableOrPrincipalName',
				area: 'row',
				},
				{
				caption: 'Date Year',
				dataField: 'Date',
				area: 'column',
				dataType: 'date',
				groupInterval: 'year',
				},
				{
				caption: 'Date Month',
				dataField: 'Date',
				area: 'column',
				dataType: 'date',
				groupInterval: 'month',
				},
				{
				caption: 'Date Day',
				dataField: 'Date',
				area: 'column',
				dataType: 'date',
				groupInterval: 'day',
				},
				{
				caption: 'Mapped Count',
				dataField: 'MappedCount',
				dataType: 'number',
				summaryType: 'sum',
				area: 'data',
				},
				{
				caption: 'Reviewed Count',
				dataField: 'ReviewedCount',
				dataType: 'number',
				summaryType: 'sum',
				area: 'data',
				},
				{
				caption: 'Total Count',
				dataField: 'TotalCount',
				dataType: 'number',
				summaryType: 'sum',
				area: 'data',
				},
				{
				caption: 'Unmapped Count',
				dataField: 'UnmappedCount',
				dataType: 'number',
				summaryType: 'sum',
				area: 'data',
				},
			],
			store: res
			};
		}
		});
  }
}
